import { render, staticRenderFns } from "./ImageAlbumCard.vue?vue&type=template&id=46ab0fe2&scoped=true"
import script from "./ImageAlbumCard.vue?vue&type=script&lang=js"
export * from "./ImageAlbumCard.vue?vue&type=script&lang=js"
import style0 from "./ImageAlbumCard.vue?vue&type=style&index=0&id=46ab0fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab0fe2",
  null
  
)

export default component.exports